import { c as _c } from "react/compiler-runtime";
import { MenuItem } from "@website/ui/menu/menu-item";
import styles from "@website/ui/menu/menu.module.scss";
import { MenuPropertiesType } from "@website/ui/menu/menu.types";
import { FC, Fragment } from "react";
export const Menu: FC<MenuPropertiesType> = properties => {
  const $ = _c(10);
  const {
    className,
    list,
    divider,
    value,
    onChange,
    size,
    name
  } = properties;
  const t0 = `${styles.menu} ${className || ""}`;
  let t1;
  if ($[0] !== divider || $[1] !== list || $[2] !== name || $[3] !== onChange || $[4] !== size || $[5] !== value) {
    t1 = list ? list.map((item, index) => <Fragment key={item.value}>{index === 0 ? null : <div className={`${styles.divider} ${divider ? styles[divider] : ""}`} />}<MenuItem EndIcon={item.EndIcon} StartIcon={item.StartIcon} description={item.description} disabled={item.disabled} key={item.value} name={name} onClick={onChange} selected={item.value === value} size={size} title={item.title} value={item.value} /></Fragment>) : null;
    $[0] = divider;
    $[1] = list;
    $[2] = name;
    $[3] = onChange;
    $[4] = size;
    $[5] = value;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== t0 || $[8] !== t1) {
    t2 = <div className={t0} data-testid="muenu">{t1}</div>;
    $[7] = t0;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
};